import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as S from './styles';

import { Page } from '@zillow/constellation';

import houseWithLessHills from 'images/zrmLogin/houseWithLessHills.png';
import easyToBeLandlordBanner from 'images/zrmLogin/easyToBeLandlordBanner.png';
import houseWithMoreHills from 'images/zrmLogin/houseWithMoreHills.png';

import Helmet from 'react-helmet';
import loadable from '@loadable/component';
const RegLogin = loadable(() => import('@zillow/reg-login'));

import type { State } from 'app/shared/types/State';

const ZRMLoginPage = () => {
    const urlParameters = useSelector((state: State) => state.router.location.query);
    const redirectUrl = urlParameters?.url
        ? decodeURIComponent(urlParameters.url)
        : 'https://www.zillow.com/rental-manager/properties';
    const [isClientMounted, setIsClientMounted] = useState(false);

    // RegLogin can only be mounted after the client loads.
    useEffect(() => setIsClientMounted(true), []);

    return (
        <Page backgroundColor="white">
            <Helmet>
                <title>Please sign in | Zillow Rental Manager</title>
                <meta name="description" content="Sign in or Register | Zillow Rental Manager." />
            </Helmet>

            {isClientMounted && (
                <S.FlexContainer
                    display="flex"
                    justifyContent="space-between"
                    flexDirection={{ default: 'column', md: 'row' }}
                >
                    <S.MobileWebImage alt="" src={houseWithLessHills} />
                    <S.RegLoginContainer>
                        <RegLogin
                            headerText="Sign up for Zillow Rental Manager"
                            redirectUrl={redirectUrl}
                            showProRegCheckbox={false}
                            signInWithAppleEnabled
                            isNativeApp={true}
                        />
                    </S.RegLoginContainer>
                    <S.DesktopImagesContainer>
                        <S.Banner
                            src={easyToBeLandlordBanner}
                            alt="It's easier than ever to be a landlord. Save time with our property management 
                            tools that help you get what you need - signed leases and rent payments."
                        />
                        <S.BottomAlignedImage src={houseWithMoreHills} alt="" />
                    </S.DesktopImagesContainer>
                </S.FlexContainer>
            )}
        </Page>
    );
};

export default ZRMLoginPage;
